<template>
<div class="cockpit-header" v-if="campaign">
  <div class="item">
    <div class="a">
      <svgicon name="car" color="#00b1eb" scale="1.5"></svgicon>
      <div>{{$t('campaigns.vehicles')}}</div>
    </div>
    <div class="b">{{ campaign.cars }}</div>
  </div>
  <div class="item">
    <div class="a">
      <svgicon name="contacts" color="#00b1eb" scale="1.5"></svgicon>
      <div>{{$t('campaigns.impressions_zone')}}</div>
    </div>
    <div class="b">{{ campaign.impressions['In zone'].toLocaleString(lang) }}</div>
  </div>
  <div class="item">
    <div class="a">
      <svgicon name="eye" color="#00b1eb" scale="1.5"></svgicon>
      <div>
        {{$t('campaigns.impressions_ttl')}}
      </div>
    </div>
    <div class="b">{{ impressions.toLocaleString(lang) }}</div>
  </div>
  <div class="item">
    <div class="a">
      <svgicon name="money" color="#00b1eb" scale="1.5"></svgicon>
      <div>
        {{$t('campaigns.budget_spent')}}
      </div>
    </div>
    <div class="b">{{ budget.toLocaleString(lang,{ style: 'currency', currency: 'EUR',maximumFractionDigits: 0,minimumFractionDigits: 0 }) }}</div>
  </div>
  <div class="item" @click="image_pointer++">
    <img :src="campaign.fleets[image_index]?campaign.fleets[image_index].cover_thumb: null" class="car-preview" height='50px'>
  </div>
</div>
</template>

<script>
import {
  mapState
} from 'vuex'
import '../icons'

export default {
  props: ['campaign'],
  data: function () {
    return {
      image_pointer: 0
    }
  },
  computed: {
    image_index () {
      return this.image_pointer % this.campaign.fleets.length
    },
    impressions () {
      return this.campaign.impressions['In zone'] + this.campaign.impressions['Out zone']
    },
    budget () {
      let campaign = this.campaign
      if ('budget_sofar' in campaign) {
        return campaign.budget_sofar
      }
      return campaign.budget
    },
    ...mapState(['lang'])
  }
}
</script>
<style scoped lang="stylus" src="../styles/_CockpitHeader.styl"/>



// WEBPACK FOOTER //
// src/components/CockpitHeader.vue